import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { login } from '../store/authSlice';

const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user, error } = useAppSelector((s) => s.auth);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user) navigate('/', { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    await dispatch(login({ email, password }));
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-army-950 flex items-center justify-center p-4">
      <div className="w-full" style={{ maxWidth: '400px' }}>

        {/* Logo */}
        <div className="text-center mb-10">
          <div className="text-4xl mb-2">🍽</div>
          <span className="text-neon font-bold text-2xl tracking-tight">supper</span>
          <p className="text-gray-500 text-sm mt-1">Meal planning made easy</p>
        </div>

        {/* Card */}
        <div className="bg-navy-900 rounded-2xl p-8 shadow-2xl" style={{ border: '1px solid #1c2d47' }}>
          <h1 className="text-white font-semibold text-xl mb-6">Sign in to your account</h1>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-semibold text-gray-400 uppercase tracking-widest mb-2">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                className="w-full px-4 py-3 bg-army-900 rounded-lg text-white placeholder-gray-600 text-sm focus:outline-none transition-colors"
                style={{ border: '1px solid #2a5230' }}
                onFocus={e => e.currentTarget.style.borderColor = '#4ade80'}
                onBlur={e => e.currentTarget.style.borderColor = '#2a5230'}
                placeholder="you@example.com"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-400 uppercase tracking-widest mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 bg-army-900 rounded-lg text-white placeholder-gray-600 text-sm focus:outline-none transition-colors"
                style={{ border: '1px solid #2a5230' }}
                onFocus={e => e.currentTarget.style.borderColor = '#4ade80'}
                onBlur={e => e.currentTarget.style.borderColor = '#2a5230'}
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div className="bg-rose-950 border border-rose-800 text-rose-300 text-sm px-4 py-3 rounded-lg">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={submitting}
              className="w-full py-3 font-bold rounded-lg text-sm transition-all mt-2"
              style={{
                backgroundColor: '#4ade80',
                color: '#0e1f10',
                opacity: submitting ? 0.6 : 1,
              }}
            >
              {submitting ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
